import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from '../components/layout/Navigation';
import Footer from '../components/layout/Footer';
import FeatureCard from '../components/common/FeatureCard';
import HowItWorksCard from '../components/common/HowItWorksCard';
import BecomePart from '../components/common/BecomePart';
// import PricingCard from '../components/common/PricingCard';
import { features, howItWorks, institutionPlans, pricingPlans } from '../config/content';
import MobileLanding from '../components/landingpage/MobileHero';
import DesktopLanding from '../components/landingpage/DesktopHero';

function LandingPage({ isMenuOpen, setIsMenuOpen }) {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  const handleTeacherSignup = () => {
    navigate('/signup', { state: { userType: 'teacher' } });
  };

  const handleInstitutionSignup = () => {
    navigate('/signup', { state: { userType: 'institution' } });
  };

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768); // 1024px is the standard lg breakpoint in Tailwind
    };

    // Initial check
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <>
      <Navigation isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      {/* Hero Section */}
      {isMobile ? <MobileLanding navigate={navigate} /> : <DesktopLanding navigate={navigate} />}
      {/* Features Section */}
      <div id="why-teacher-jobs" className="py-20 bg-primary-200">
        <div className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl mt-[-2rem] md:text-4xl md:mt-[-2rem] lg:text-4xl lg:mt-[-2rem] xl:text-5xl xl:mt-[-2rem] font-medium text-center mb-12 text-primary-text">
            Why Are We Here?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <FeatureCard key={index} {...feature} />
            ))}
          </div>
        </div>
      </div>
      {/* How to be part of Teachers jobs.in */}
      <div id="for-teachers" className="py-20 bg-primary-50">
        <div className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-[1.3rem] mt-[-2rem] md:text-2xl md:mt-[-2rem] lg:text-3xl lg:mt-[-2rem] xl:text-4xl xl:mt-[-2rem] font-medium text-center mb-12 text-primary-text">
            How Aspiring Teachers and Teachers can be part of Find Teachers ?
          </h2>
          <h3 className="text-[0.8rem] mt-[-2rem] md:text-1xl md:mt-[-2rem] lg:text-1xl lg:mt-[-2rem] xl:text-2xl xl:mt-[-2rem] font-light text-center mb-12 text-primary-text">
            Our simple three-step process makes it easy to get started
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {howItWorks.map((item, index) => (
              <div key={index} onClick={handleTeacherSignup} className="cursor-pointer">
                <HowItWorksCard {...item} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Institution Section */}
      <div id="for-institutions" className="py-20 bg-primary-100">
        <div className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl mt-[-2rem] md:text-4xl md:mt-[-2rem] lg:text-4xl lg:mt-[-2rem] xl:text-5xl xl:mt-[-2rem] font-medium text-center mb-12 text-primary-text">
            How Institutions can be part of Find Teachers ?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {institutionPlans.map((plan, index) => (
              <div key={index} onClick={handleInstitutionSignup} className="cursor-pointer">
                <BecomePart {...plan} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Pricing Section */}
      {/* <div className="py-20 bg-white">
        <div className="container max-w-7xl mx-auto  mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12 text-primary-500">Simple, Transparent Pricing</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {pricingPlans.map((plan, index) => (
              <PricingCard key={index} {...plan} />
            ))}
          </div>
        </div>
            </div> */}

      <Footer />
    </>
  );
}

export default LandingPage;
